import React from "react"
import PropTypes from "prop-types"

export default class SectionLeft extends React.Component {
  static propTypes = {
    image: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    id: PropTypes.string
  }

  render() {
    return (
      <div className={"row my-5 no-gutters"} id={this.props.id}>
        <div className={"col-lg-4 bg-primary text-white align-self-center mr-lg-n5 text-center p-5 shadow"} style={{ zIndex: 1 }}>
          <h2
            style={{
              fontFamily: "Anton",
              fontWeight: 400,
              fontSize: "2rem"
            }}
            className={'text-uppercase'}
          >
            {this.props.title}
          </h2>
          {this.props.children}
        </div>
        <div className={"d-none d-lg-block col-lg-8 align-self-center"}>
          <img src={this.props.image} alt={this.props.alt} className={"img-fluid"}/>
        </div>
      </div>
    )
  }
}
